<template>
 <span class="badge badge-pill px-2 py-1" :class="activeClass">
   <span  class="fas fa-circle small"></span>
   {{holiday.status === 1 ? 'activo' : 'inactivo'}}
 </span>
</template>
<script>

  /* STATUS */
  const INACTIVE = 0;
  const ACTIVE = 1;

  export default {
    props: ['holiday'],
    name: "lock-badge",
    computed: {
      activeClass() {
        switch (this.holiday.status) {
          case INACTIVE:
            return 'badge-secondary';
          case ACTIVE:
            return 'badge-primary';
          default:
            return '';
        }
      }
    }
  }
</script>
